import { Component, Input, OnDestroy, ViewChild } from '@angular/core';
import { IonSearchbar, ModalController } from '@ionic/angular';
import { Observable, Subject } from 'rxjs';

declare const google: any;

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'boxx-location-picker',
  templateUrl: './location-picker.component.html',
  styleUrls: ['./location-picker.component.scss'],
})
export class LocationPickerComponent implements OnDestroy {
  @ViewChild('placePickerSB', { static: false }) searchBar: IonSearchbar;
  @Input() requestGeocoder: boolean = true;
  
  destroyed$ = new Subject<boolean>();
  loading$: Observable<boolean>;

  searchResults: Array<any> = [];

  translations: any;

  mapsService: any;

  constructor(private modalCtrl: ModalController) {
    this.mapsService = new google.maps.places.AutocompleteService();
  }

  ngOnDestroy() {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  ionViewDidEnter() {
    setTimeout(() => {
      this.searchBar.setFocus();
    }, 200);
  }

  onInput(event: any) {
    const query = event.target.value;
    this.searchResults = [];

    if (!query) {
      return;
    }

    const config = {
      types: [], // other types available in the API: 'address 'establishment', 'regions', and 'cities'
      input: query,
    };

    this.mapsService.getPlacePredictions(config, (predictions, status) => {
      if (predictions && predictions.length > 0) {
        predictions.forEach((prediction) => {
          this.searchResults.push(prediction);
        });
      } else {
        const locationDesc = {
          description: query,
          // eslint-disable-next-line @typescript-eslint/naming-convention
          place_id: 'default_place_id',
        };

        this.searchResults.push(locationDesc);
      }
    });
  }

  async close() {
    this.modalCtrl.dismiss(/*{someData: ...} */);
  }

  async chooseItem(item: any) { 
    if(this.requestGeocoder){
      this.getSpecificData(item.place_id, item.description)
    }
    else{
      this.modalCtrl.dismiss({
        description: item.description,
        id: item.place_id
      });
    }
  }

  async getSpecificData(placeId, street){
    let city = '';
    let country = '';
    let zip = '';
    let state = '';
    let longitude = '';
    let latitude = '';
    let locality = '';
    const geocoder = new google.maps.Geocoder();
    const { results } = await geocoder.geocode({ placeId: placeId });
    if (results[0]) {
      longitude = (results[0].geometry.location.lng()) ? results[0].geometry.location.lng() : '';
      latitude = (results[0].geometry.location.lat()) ? results[0].geometry.location.lat() : '';

      for (var i = 0; i < results[0].address_components.length; i++) {
        for (var j = 0; j < results[0].address_components[i].types.length; j++) {
          if (results[0].address_components[i].types[j] == "postal_code") {
            zip = results[0].address_components[i].long_name;
          }
        }

        if (results[0].address_components[i].types[0] === "locality") {
            locality = results[0].address_components[i].long_name
        }

        if (results[0].address_components[i].types[0] === "administrative_area_level_1") {
          state = results[0].address_components[i].long_name;
        }

        if (results[0].address_components[i].types[0] === "locality") {
          city = results[0].address_components[i].long_name;
        }
        if (results[0].address_components[i].types[0] === "country") {
          country = results[0].address_components[i].long_name;
        }
      }
    }
    if(city && city !== ''){
      const splitFullStreet = street.split(', '+city);
      street = splitFullStreet[0];
    }

    this.modalCtrl.dismiss({
      description: street,
      id: placeId,
      detailData: {
        city: city,
        country: country,
        latitude: latitude,
        longitude: longitude,
        street: street,
        state: state,
        zip: zip,
        locality: locality
      }
    });
  }

  select() {}
}
